import { FormHelperText, Stack } from '@mui/material';
import { AssortmentTag } from '@retail/my-assortment/types';
import { useProductsTFunction } from '@retail/products/i18n';
import { SupplierItemAssortmentTag } from '@retail/products/types';
import { notBeforeToday } from '@retail/utils';
import dayjs from 'dayjs';
import { DateSelectField } from '../DateSchema/DateSelectField';
import { TagDateRangeInfo } from '../MgItem/AssortmentTag/TagDateRangeInfo';

interface Props {
  tag: SupplierItemAssortmentTag;
  /** The sub-assortment itself, whose own validity period limits the dates on the item. */
  assortmentTag?: AssortmentTag;
  onChange: (tag: SupplierItemAssortmentTag) => void;
}

/** From/to dates for one tag on an item, shared by the add menus and the edit popover. */
export function TagDateFields({ tag, assortmentTag, onChange }: Props) {
  const t = useProductsTFunction();
  const hasStarted = dayjs(tag.validFrom).isBefore(dayjs(), 'day');

  return (
    <Stack gap={2}>
      <Stack flexDirection="row" gap={2}>
        <DateSelectField
          includeUnderline
          label={t('products.mgItem.fromDate.label') + ':'}
          value={tag.validFrom}
          disabled={hasStarted}
          minDate={notBeforeToday(assortmentTag?.validFrom)}
          maxDate={tag.validTo ?? assortmentTag?.validTo}
          setNewDate={(newDate) => newDate && onChange({ ...tag, validFrom: newDate })}
        />
        <DateSelectField
          clearable
          includeUnderline
          label={t('products.mgItem.toDate.label') + ':'}
          value={tag.validTo}
          minDate={notBeforeToday(tag.validFrom)}
          maxDate={assortmentTag?.validTo}
          setNewDate={(newDate) => onChange({ ...tag, validTo: newDate ?? undefined })}
        />
      </Stack>

      {hasStarted && (
        <FormHelperText sx={{ m: 0 }}>
          {t('products.mgItem.assortmentTags.alreadyStarted')}
        </FormHelperText>
      )}

      {assortmentTag && <TagDateRangeInfo assortmentTag={assortmentTag} />}
    </Stack>
  );
}
